import React from 'react';
import ReportsList from './ReportsList';

const AlarmReportsIntl = () => {
  return (
    <ReportsList
      endpoint="listPdfFolder/?folder=alarm-reports"
      title="International Alarm Reports"
      allColumns={false}
      enableFilters={true}
      disableReportTypeFilter={true}
      filenamePrefix="alarm-reports"
      filenameFilter="-Intl-"
    />
  );
};

export default AlarmReportsIntl;
